module.exports = __webpack_public_path__ + "static/blue-51ef72403a97ee69dbb9528192645dc1.jpg";